export default __webpack_public_path__ + "static/media/Snd_LowerFUpDown.d74c742f.mp3";